import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from "antd";

// Core application components
import CustomerHeader from "./components/CustomerHeader";
import CustomerContent from "./components/CustomerContent";
import CustomerFooter from './components/CustomerFooter';
import CustomerSider from './components/CustomerSider';
import LazySpinner from "./components/LazySpinner";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import LoginPage from "./pages/Login";

// Development tools
import {AuthProvider} from "./services";

// A wrapper component that checks the current route
const AppContent: React.FC = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  
  return (
    <Layout className="app-layout">
      <CustomerHeader />
      <Layout hasSider>
        {!isLoginPage && <CustomerSider />}
        <Layout className="content-layout">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <CustomerContent />
                <LazySpinner />
              </ProtectedRoute>
            } />
          </Routes>
          <CustomerFooter />
        </Layout>
      </Layout>
    </Layout>
  );
};

/**
 * Main application component
 * 
 * Renders the main application layout including header, sider, content area,
 * footer, and utility components like loading spinners and dev tools.
 */
const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
};

export default App;
